/**
 * Reads the value of the cookie named exactly `name`.
 *
 * @param  {string} name Full name of the cookie
 *
 * @return {string | null} the cookie value, or null when no such cookie is set
 */
export const getCookie = (name: string): string | null => {
  const cookie = document.cookie
    .split(";")
    .map((part) => part.trim())
    .find((part) => part.startsWith(`${name}=`));

  if (!cookie) {
    return null;
  }

  return cookie.slice(cookie.indexOf("=") + 1) || null;
};

export const hasCookie = (name: string) => getCookie(name) !== null;
